module.exports = __webpack_public_path__ + "static/media/sa-logo-white.38bd6e07.svg";